import { Vue, Component } from 'vue-property-decorator'

@Component
export default class Navigation extends Vue {
  private open = false;

  private toggle (): void {
    this.open = !this.open
    this.$emit('is-open', this.open)
  }

  private navigate (destination: string): void {
    this.open = false
    this.$emit('is-open', this.open)
    this.$router.push({ name: destination })
  }
}
